<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <!-- Mantra Title -->
            <div class="vx-col w-1/2 mb-2">
              <vs-input
                icon-pack="feather"
                class="w-full"
                v-validate="'required|exclude_special_char'"
                v-model="form.title"
                label="Mantra Title *"
                placeholder="Waheguru"
                name="Mantra Title"
                id="mantra-title"
              />
              <span class="text-danger text-sm" v-show="errors.has('Mantra Title')">{{ errors.first('Mantra Title') }}</span>
            </div>

            <!-- Bani of -->
            <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label">Bani of *</label>
              <select-2
                class="w-full category-input"
                name="Bani of"
                placeholder="Select Writer"
                :value="form.written_by"
                @input="(item) => (form.written_by = item && item.value)"
                autocomplete
                :ssr="true"
                :multiple="false"
                v-validate="'required'"
                action="creator/get"
                :options="creators"
                data-vv-as="Bani of"
              />
              <span class="text-danger text-sm" v-show="errors.has('Bani of')">{{ errors.first('Bani of') }}</span>
            </div>

            <!-- Day Time -->
            <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label">Day Time</label>
              <select-2
                class="w-full"
                :name="'day_time'"
                placeholder="Morning"
                :options="MANTRA_DAY_TIME"
                autocomplete
                :ssr="true"
                :multiple="true"
                :clearable="!!form.day_time.length"
                :value="form.day_time"
                data-vv-as="Day Time"
                @input="(item) => (form.day_time = item && item.value)"
              />
              <span class="text-danger text-sm" v-show="errors.has(`day_time`)">{{ errors.first(`day_time`) }}</span>
            </div>

            <!-- About -->
            <div class="vx-col w-full mb-2">
              <label class="vs-input--label block" for="About">About *</label>
              <vs-textarea
                placeholder="This mantra is a powerful invocation to the Supreme Being, it is commonly recited at the beginning of religious ceremonies and spiritual practices. It signifies the recognition and love of the Divine."
                class="w-full input mb-0"
                id="about"
                v-validate="'required|exclude_special_char'"
                name="about"
                v-model="form.about"
                :rows="6"
                data-vv-as="About"
              />
              <span class="text-danger text-sm" v-show="errors.has('about')">{{ errors.first('about') }}</span>
            </div>

            <!-- Meaning -->
            <div class="vx-col w-full mb-2 block">
              <label class="vs-input--label block" for="Meaning">What Dose Mean *</label>
              <vs-textarea
                placeholder="Provide the meaning of the mantra here."
                class="w-full input mb-0"
                id="meaning"
                v-validate="'required|exclude_special_char'"
                name="meaning"
                v-model="form.meaning"
                :rows="6"
                data-vv-as="Meaning"
              />
              <span class="text-danger text-sm" v-show="errors.has('meaning')">{{ errors.first('meaning') }}</span>
            </div>

            <!-- Mantra -->
            <!-- <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label block" for="Mantra">Mantra *</label>
              <vs-textarea placeholder="Waheguru" class="w-full input mb-0" id="mantra" v-validate="'required'" name="mantra" v-model="form.mantra" :rows="6" data-vv-as="Mantra" />
              <span class="text-danger text-sm" v-show="errors.has('mantra')">{{ errors.first('mantra') }}</span>
            </div> -->

            <!-- Audio -->
            <div class="vx-col w-8/12 cursor-pointer mb-2">
              <label class="vs-input--label block">Audio</label>

              <input
                type="file"
                v-validate="'ext:mp3,wav'"
                class="border p-2 rounded w-full"
                name="audio"
                ref="files"
                accept=".mp3,.wav"
                @change="handleAudioUpload"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                data-vv-as="Audio"
              />
              <span class="text-danger text-sm" v-show="errors.has('audio')">{{ errors.first('audio') }}</span>
            </div>
            <div class="mt-4 w-4/12">
              <div class="relative" v-if="preview_audio">
                <audio ref="audioPlayer" :src="preview_audio" controls></audio>
              </div>
            </div>

            <!-- Transcript -->
            <div class="vx-col w-8/12 cursor-pointer mb-2">
              <div class="flex items-center mb-2">
                <label class="vs-input--label block">Transcript</label>

                <vx-tooltip :text="'Download Sample Transcript File'">
                  <vs-button @click="downloadSampleTranscript" color="success" type="gradient" icon-pack="feather" icon="icon-download" class="ml-2 small-icon-button"></vs-button>
                </vx-tooltip>
              </div>
              <input
                type="file"
                class="border p-2 rounded w-full"
                name="transcript"
                accept=".json"
                v-validate="'ext:json'"
                @change="handleTranscriptUpload"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                data-vv-as="Transcript"
              />
              <span class="text-danger text-sm" v-show="errors.has('transcript')">{{ errors.first('transcript') }}</span>
            </div>

            <!-- View Transcript Button -->
            <div class="mt-8 w-4/12" v-if="preview_transcript && preview_transcript.results">
              <vs-button color="primary" @click="toggleTranscriptModal">View Transcript</vs-button>
            </div>

            <!-- Image -->
            <div class="vx-col w-8/12 cursor-pointer mb-2">
              <label class="vs-input--label block">Image *</label>
              <input
                :key="fileKey"
                type="file"
                class="border p-2 rounded w-full"
                accept=".jpg, .png , .jpeg"
                @change="handleFileUpload"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                data-vv-as="Image"
              />
              <input type="hidden" name="image" v-model="form.image" v-validate="imagevalidationRule" data-vv-as="Image" />
              <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
              <div class="mt-5">
                <div class="relative" v-if="preview_image">
                  <div class="h-64 w-64 mt-5 overflow-hidden">
                    <img height="200px" width="250px" :src="preview_image" alt="Image Preview" class="object-fit" />
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col w-full cursor-pointer mb-2">
              <div v-for="(row, rowIndex) in form.slok_n_pauri_fragment" :key="rowIndex" class="mb-3 brd1">
                <div class="p-6 rounded-md mb-2">
                  <div class="mb-4 flex gap-4 items-center">
                    <h4 class="text-xl font-semibold">Path</h4>
                    <!-- Audio Controls - Redesigned -->
                    <div class="audio-controls flex gap-2" v-if="row.path.punjabi.id">
                      <!-- Record Button -->
                      <vs-button v-if="!recordingStates[`${row._id}-path-punjabi`]"
                        @mousedown="startRecording(row._id, 'path', 'punjabi')"
                        @mouseup="stopRecording(row._id, 'path', 'punjabi')"
                        @mouseleave="stopRecording(row._id, 'path', 'punjabi')"
                        @touchstart="startRecording(row._id, 'path', 'punjabi')"
                        @touchend="stopRecording(row._id, 'path', 'punjabi')" icon="mic" color="primary"
                        class="hold-to-record rounded-full audio-button">
                      </vs-button>
                      <vs-button v-else @mouseup="stopRecording(row._id, 'path', 'punjabi')"
                        @mouseleave="stopRecording(row._id, 'path', 'punjabi')"
                        @touchend="stopRecording(row._id, 'path', 'punjabi')" icon="stop" color="danger"
                        class="rounded-full audio-button">
                      </vs-button>

                      <!-- Tag Buttons -->
                      <div class="flex gap-2 items-center ml-2">
                        <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'audio')">Tag
                          Audios</vs-button>
                        <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'video')">Tag
                          Videos</vs-button>
                        <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'emotion')">Tag
                          Emotions</vs-button>
                      </div>

                      <!-- Audio Preview -->
                      <div v-if="audioElements[`${row._id}-path-punjabi`] || row.path.punjabi.audioUrl"
                        class="audio-preview flex items-center gap-2">
                        <audio controls :src="audioUrls[`${row._id}-path-punjabi`] || row.path.punjabi.audioUrl"
                          class="audio-player" @pause="handleAudioPause(row._id, 'path', 'punjabi')"
                          @play="handleAudioPlay(row._id, 'path', 'punjabi')"
                          :ref="`audio-${row._id}-path-punjabi`"></audio>
                        <vs-button @click="deleteAudio(row._id, 'path', 'punjabi')" class="ml-2" color="danger"
                          type="gradient" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </div>
                    </div>
                  </div>

                  <!-- Content Sections -->
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Punjabi -->
                    <div class="w-full">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'path-punjabi-' + rowIndex">Punjabi * </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.path.punjabi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.path.punjabi.id)"> {{ row.path.punjabi.id }}</label>
                        </vx-tooltip>
                      </div>

                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਦੀ ਬਾਣੀ ਦਾ ਅਰਥ ਸਿੱਖਿਆ ਅਤੇ "
                            class="w-full input mb-0 vs-textarea"
                            :id="'path-punjabi-' + rowIndex"
                            v-validate="'required|exclude_special_char'"
                            :name="'path-punjabi-' + rowIndex"
                            v-model="row.path.punjabi.content"
                            :rows="3"
                            data-vv-as="Punjabi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Punjabi Path`" v-if="row.path.punjabi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-path-punjabi-' + rowIndex"
                            :disabled="!row.path.punjabi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.path.punjabi, 'path-punjabi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('path-punjabi-' + rowIndex)">
                        {{ errors.first('path-punjabi-' + rowIndex) }}
                      </span>
                    </div>

                    <!-- Hindi -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'path-hindi-' + rowIndex">Hindi </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.path.hindi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.path.hindi.id)"> {{ row.path.hindi.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="ੴ सतिनामु करता पुरखु निर्भउ निर्वैरुअकाल मूरति अजूनी सैभं गुर"
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'path-hindi-' + rowIndex"
                            :name="'path-hindi-' + rowIndex"
                            v-model="row.path.hindi.content"
                            :rows="3"
                            data-vv-as="Hindi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Hindi Path`" v-if="row.path.hindi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-path-hindi-' + rowIndex"
                            :disabled="!row.path.hindi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.path.hindi, 'path-hindi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('path-hindi-' + rowIndex)">{{ errors.first('path-hindi-' + rowIndex) }}</span>
                    </div>

                    <!-- English -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'path-english-' + rowIndex">English </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.path.english.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.path.english.id)"> {{ row.path.english.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="ੴ Sat Naam Karta Purakh Nirbhau NirvairAkaal"
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'path-english-' + rowIndex"
                            :name="'path-english-' + rowIndex"
                            v-model="row.path.english.content"
                            :rows="3"
                            data-vv-as="English"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update English Path`" v-if="row.path.english.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-path-english-' + rowIndex"
                            :disabled="!row.path.english.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.path.english, 'path-english-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('path-english-' + rowIndex)">{{ errors.first('path-english-' + rowIndex) }}</span>
                    </div>
                  </div>

                  <vs-divider class="my-4"></vs-divider>

                  <!-- transliteration Section -->
                  <div class="mb-4 flex gap-4 items-center">
                    <h4 class="text-xl font-semibold">Transliteration</h4>
                    <div class="flex gap-2 items-center ml-2">
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'audio')">Tag
                        Audios</vs-button>
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'video')">Tag
                        Videos</vs-button>
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'emotion')">Tag
                        Emotions</vs-button>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Punjabi -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'transliteration-punjabi-' + rowIndex">Punjabi </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.transliteration.punjabi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.transliteration.punjabi.id)"> {{ row.transliteration.punjabi.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਦੀ ਬਾਣੀ ਦਾ ਅਰਥ ਸਿੱਖਿਆ ਅਤੇ"
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'transliteration-punjabi-' + rowIndex"
                            :name="'transliteration-punjabi-' + rowIndex"
                            v-model="row.transliteration.punjabi.content"
                            :rows="3"
                            data-vv-as="Punjabi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Punjabi Transliteration`" v-if="row.transliteration.punjabi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-transliteration-punjabi-' + rowIndex"
                            :disabled="!row.transliteration.punjabi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.transliteration.punjabi, 'transliteration-punjabi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('transliteration-punjabi-' + rowIndex)">{{ errors.first('transliteration-punjabi-' + rowIndex) }}</span>
                    </div>

                    <!-- Hindi -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'transliteration-hindi-' + rowIndex">Hindi </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.transliteration.hindi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.transliteration.hindi.id)"> {{ row.transliteration.hindi.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="श्री गुरु नानक देव जी की वाणी का अर्थ जीवन की गहराई"
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'transliteration-hindi-' + rowIndex"
                            :name="'transliteration-hindi-' + rowIndex"
                            v-model="row.transliteration.hindi.content"
                            :rows="3"
                            data-vv-as="Hindi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Hindi Transliteration`" v-if="row.transliteration.hindi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-transliteration-hindi-' + rowIndex"
                            :disabled="!row.transliteration.hindi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.transliteration.hindi, 'transliteration-hindi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('transliteration-hindi-' + rowIndex)">{{ errors.first('transliteration-hindi-' + rowIndex) }}</span>
                    </div>

                    <!-- English -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'transliteration-english-' + rowIndex">English </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.transliteration.english.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.transliteration.english.id)"> {{ row.transliteration.english.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="The meaning of Sri Guru Nanak Dev Ji's Bani "
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'transliteration-english-' + rowIndex"
                            :name="'transliteration-english-' + rowIndex"
                            v-model="row.transliteration.english.content"
                            :rows="3"
                            data-vv-as="English"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update English Transliteration`" v-if="row.transliteration.english.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-transliteration-english-' + rowIndex"
                            :disabled="!row.transliteration.english.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.transliteration.english, 'transliteration-english-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('transliteration-english-' + rowIndex)">{{ errors.first('transliteration-english-' + rowIndex) }}</span>
                    </div>
                  </div>
                  <vs-divider class="my-4"></vs-divider>
                  <!-- Vyakhya Section -->
                  <div class="mb-4 flex gap-4 items-center">
                    <h4 class="text-xl font-semibold">Vyakhya</h4>
                    <div class="flex gap-2 items-center ml-2">
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'audio')">Tag
                        Audios</vs-button>
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'video')">Tag
                        Videos</vs-button>
                      <vs-button type="border" class="tag-pill" @click="openTagModal(row, 'emotion')">Tag
                        Emotions</vs-button>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Punjabi -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'vyakhya-punjabi-' + rowIndex">Punjabi </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.vyakhya.punjabi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.vyakhya.punjabi.id)"> {{ row.vyakhya.punjabi.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="ਸ੍ਰੀ ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਦੀ ਬਾਣੀ ਦਾ ਅਰੰਭ ਉੱਥੇ ਕਰ ਰਹੇ ਹਨ ਜਿੱਥੇ ਰੱਬ  "
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'vyakhya-punjabi-' + rowIndex"
                            :name="'vyakhya-punjabi-' + rowIndex"
                            v-model="row.vyakhya.punjabi.content"
                            :rows="3"
                            data-vv-as="Punjabi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Punjabi Vyakhya`" v-if="row.vyakhya.punjabi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-vyakhya-punjabi-' + rowIndex"
                            :disabled="!row.vyakhya.punjabi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.vyakhya.punjabi, 'vyakhya-punjabi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('vyakhya-punjabi-' + rowIndex)">{{ errors.first('vyakhya-punjabi-' + rowIndex) }}</span>
                    </div>

                    <!-- Hindi -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'vyakhya-hindi-' + rowIndex">Hindi </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.vyakhya.hindi.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.vyakhya.hindi.id)"> {{ row.vyakhya.hindi.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="श्री गुरु नानक देव जी की वाणी का आरंभ वहाँ से हो रहा है जहाँ "
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'vyakhya-hindi-' + rowIndex"
                            :name="'vyakhya-hindi-' + rowIndex"
                            v-model="row.vyakhya.hindi.content"
                            :rows="3"
                            data-vv-as="Hindi"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update Hindi Vyakhya`" v-if="row.vyakhya.hindi.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-vyakhya-hindi-' + rowIndex"
                            :disabled="!row.vyakhya.hindi.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.vyakhya.hindi, 'vyakhya-hindi-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('vyakhya-hindi-' + rowIndex)">{{ errors.first('vyakhya-hindi-' + rowIndex) }}</span>
                    </div>
                    <!-- English -->
                    <div class="col-span-1">
                      <div class="flex mb-2 gap-2">
                        <strong :for="'vyakhya-english-' + rowIndex">English </strong>
                        <vx-tooltip :text="`Copy Id`" v-if="row.vyakhya.english.id">
                          <label class="flex text-sm font-medium items-center cursor-pointer" @click="copyToClipboard(row.vyakhya.english.id)"> {{ row.vyakhya.english.id }}</label>
                        </vx-tooltip>
                      </div>
                      <div class="flex items-center gap-2">
                        <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
                          <textarea
                            placeholder="Sri Guru Nanak Dev Ji begins the Bani with a concept"
                            class="w-full input mb-0 vs-textarea"
                            v-validate="'exclude_special_char'"
                            :id="'vyakhya-english-' + rowIndex"
                            :name="'vyakhya-english-' + rowIndex"
                            v-model="row.vyakhya.english.content"
                            :rows="3"
                            data-vv-as="English"
                          ></textarea>
                        </div>
                        <vx-tooltip :text="`Update English Vyakhya`" v-if="row.vyakhya.english.id">
                          <vs-button
                            class="vs-con-loading__container mr-2 bg-[#1f4e79]"
                            :id="'create-vyakhya-english-' + rowIndex"
                            :disabled="!row.vyakhya.english.content"
                            color="success"
                            type="filled"
                            icon-pack="feather"
                            @click="updateSingleRecord(row.vyakhya.english, 'vyakhya-english-' + rowIndex)"
                            icon="icon-save"
                          ></vs-button>
                        </vx-tooltip>
                      </div>
                      <span class="text-danger text-sm" v-if="errors.has('vyakhya-english-' + rowIndex)">{{ errors.first('vyakhya-english-' + rowIndex) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 w-64 vs-con-loading__container" color="success" id="create-mantra" @click="save_changes"> {{ 'Update' }}</vs-button>
                <!-- <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button> -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Transcript Preview Modal -->
    <vs-popup title="Transcript Preview" :active.sync="isTranscriptModalOpen" class="text-left">
      <div class="p-4">
        <h3 class="text-lg font-semibold mb-4 text-gray-800">Transcript Details</h3>
        <div class="max-h-96 overflow-y-auto border rounded-md p-4 bg-gray-100">
          <ul v-if="preview_transcript && preview_transcript.results" class="space-y-4">
            <li v-for="(item, index) in preview_transcript.results" :key="index" class="p-4 rounded-md shadow-md">
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">Transcript:</strong> {{ item.transcript }}</div>
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">Start Time:</strong> {{ item.startTime }}</div>
              <div class="mt-1 text-sm text-gray-500"><strong class="font-semibold">End Time:</strong> {{ item.endTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper
                  ref="cropper"
                  name="Image"
                  class="cropper-image"
                  :src="this.crop_image.src"
                  :stencil-props="{
                    aspectRatio: 12 / 12
                  }"
                />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- Tagging Modals -->
    <!-- Audio Tag Modal -->
    <vs-popup class="tag-modal" title="Tag Audios" :active.sync="showAudioTagModal">
      <div class="p-4" v-if="showAudioTagModal">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="vs-input--label">Select Audios</label>
            <select-2 class="w-full" name="tag-audios" placeholder="Select Audios" v-model="selectedAudios"
              @input="(item) => (selectedAudios = item && item.value)" autocomplete :ssr="true" :multiple="true"
              action="audio/get" />
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <vs-button color="danger" type="flat" @click="showAudioTagModal = false">Cancel</vs-button>
          <vs-button color="primary" @click="saveTag('audio')">Save Tags</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Tag Video Modal -->
    <vs-popup class="tag-modal" title="Tag Videos" :active.sync="showVideoTagModal">
      <div class="p-4" v-if="showVideoTagModal">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="vs-input--label">Select Videos</label>
            <select-2 class="w-full" name="tag-videos" placeholder="Select Videos" v-model="selectedVideos"
              @input="(item) => (selectedVideos = item && item.value)" autocomplete :ssr="true" :multiple="true"
              action="video/get" />
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <vs-button color="danger" type="flat" @click="showVideoTagModal = false">Cancel</vs-button>
          <vs-button color="primary" @click="saveTag('video')">Save Tags</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Tag Emotions Modal -->
    <vs-popup class="tag-modal emotions-modal" title="Tag Emotions" :active.sync="showEmotionsTagModal">
      <div class="p-4" v-if="showEmotionsTagModal">
        <div class="emotions-grid">
          <div v-for="emotion in emotionsList" :key="emotion.value" class="emotion-card"
            :class="{ 'emotion-card--selected': selectedEmotions.includes(emotion.value) }"
            @click="toggleEmotion(emotion.value)">
            <div class="emotion-card__check">
              <feather-icon v-if="selectedEmotions.includes(emotion.value)" icon="CheckIcon"
                svgClasses="h-4 w-4 text-white" />
            </div>
            <div class="emotion-card__label">{{ emotion.label }}</div>
            <div class="emotion-card__emoji">{{ emotion.emoji }}</div>
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-6">
          <vs-button color="danger" type="flat" @click="showEmotionsTagModal = false">Cancel</vs-button>
          <vs-button color="primary" @click="saveTag('emotion')">Save Tags</vs-button>
        </div>
      </div>
    </vs-popup>
  </vs-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
export default {
  /** Page Name */
  name: 'AddUpdate',

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      breadcrumb: [],
      MANTRA_DAY_TIME: [],
      creators: [],
      isUpdate: false,
      form: {
        title: null,
        meaning: null,
        written_by: '',
        about: '',
        image: null,
        // mantra: '',
        day_time: [],
        transcript: null,
        audio: null,
        type: 'Mantra',
        solo_reading: true,
        slok_n_pauri_fragment: [
          {
            path: {
              punjabi: {
                content: ''
              },
              hindi: {
                content: ''
              },
              english: {
                content: ''
              }
            },
            transliteration: {
              punjabi: {
                content: ''
              },
              hindi: {
                content: ''
              },
              english: {
                content: ''
              }
            },
            vyakhya: {
              punjabi: {
                content: ''
              },
              hindi: {
                content: ''
              },
              english: {
                content: ''
              }
            }
          }
        ]
      },
      preview_audio: null,
      preview_transcript: null,
      isTranscriptModalOpen: false, // New data property to control the modal visibility
      preview_image: null,
      crop_image: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenImageCrop: false,
      showAudioTagModal: false,
      showVideoTagModal: false,
      showEmotionsTagModal: false,
      tagRowId: null,
      tagSearchQuery: '',
      selectedAudios: [],
      selectedVideos: [],
      selectedEmotions: [],
      rowTags: {},
      emotionsList: [
        { value: 'happy', label: 'Happy', emoji: '😊' },
        { value: 'sad', label: 'Sad', emoji: '😢' },
        { value: 'fear', label: 'Fear', emoji: '😱' },
        { value: 'anger', label: 'Anger', emoji: '😠' },
        { value: 'surprised', label: 'Surprised', emoji: '😐' },
        { value: 'guilt', label: 'Guilt', emoji: '😥' },
        { value: 'confused', label: 'Confused', emoji: '🤔' },
        { value: 'in_love', label: 'In Love', emoji: '🥰' }
      ]
    }
  },

  /** computed */
  computed: {
    ...mapState('mantra', ['createLoading']),
    ...mapState('solo-book', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    imagevalidationRule() {
      return !this.isUpdate ? 'required' : ''
    }
  },

  /** created */
  async created() {
    await this.$store.dispatch('mantra/show').then(async (res) => {
      const { book, slok_n_pauri_fragment } = res.data.data
      /** breadcrumb implement  */

      if (book) {
        this.isUpdate = true
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Mantra', url: '/mantra/add' },
          { title: `Edit ${book.title}`, active: true }
        ]
        /* form variable */
        this.form.title = book.title
        this.form.meaning = book.meaning
        this.form.written_by = book.written_by[0] ? book.written_by[0] : ''
        this.form.about = book.about
        // this.form.mantra = book.mantra
        this.form.day_time = book.day_time ? book.day_time : null
        this.preview_image = book.image ? book.image : null
        this.preview_audio = book.audio ? book.audio : null

        if (book.transcript) {
          try {
            const response = await fetch(book.transcript)
            const jsonData = await response.json()
            this.preview_transcript = jsonData
          } catch (error) {
            console.error('Error fetching transcript JSON:', error)
            this.preview_transcript = null
          }
        } else {
          this.preview_transcript = null
        }
      }
      if (slok_n_pauri_fragment) {
        this.form.slok_n_pauri_fragment = this.transformApiData(slok_n_pauri_fragment)
      }
    })

    const { day_time } = await this.getPreDefinedValues()
    this.MANTRA_DAY_TIME = day_time.map((value) => {
      return {
        value,
        label: value
      }
    })

    /* -------------------------------------------------------------------------- */
    /*                              Creators API Call                             */
    /* -------------------------------------------------------------------------- */
    const { data } = await this.getDropdownCreators()
    this.creators = data.results.map((value) => {
      return {
        value: value._id,
        label: value.name
      }
    })
  },

  /** methods */
  methods: {
    ...mapActions('mantra', {
      update: 'update',
      fragmentUpdate: 'fragmentUpdate'
    }),
    ...mapActions('pauri', {
      updateSingleLine: 'updateSingleLine'
    }),
    ...mapActions('common', {
      getPreDefinedValues: 'getPreDefinedValues',
      getDropdownCreators: 'getDropdownCreators'
    }),
    transformApiData(data) {
      return data.map(item => ({
        ...item,
        tags: item.tags || []
      }))
    },
    toggleEmotion(value) {
      const index = this.selectedEmotions.indexOf(value)
      if (index > -1) {
        this.selectedEmotions.splice(index, 1)
      } else {
        this.selectedEmotions.push(value)
      }
    },
    async saveTag(type) {
      if (type === 'emotion') {
        const fragment = this.form.slok_n_pauri_fragment.find(f => f._id === this.tagRowId)
        if (fragment) {
          fragment.tags = [...this.selectedEmotions]
          await this.fragmentUpdate({ id: this.tagRowId, data: { tags: fragment.tags } })
          this.showEmotionsTagModal = false
        }
      }
    },
    downloadSampleTranscript() {
      const url = 'https://devsangatapp.s3.ap-south-1.amazonaws.com/general/dummy-2-sentance-timestamping.json'

      // Fetch the file from the server as a Blob
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.blob() // Convert response to a Blob
        })
        .then((blob) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob) // Create a link to the Blob
          link.download = 'sample-transcript.json' // Specify the filename for download
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click() // Programmatically trigger the click to download

          // Clean up by revoking the Object URL and removing the link element
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        })
        .catch((error) => console.error('Download failed:', error))
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.isUpdate && !this.form.image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Image Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (this.form[key] !== null) {
            if (key === 'slok_n_pauri_fragment') {
              // Serialize slok_n_pauri_fragment to JSON before appending
              data.append(key, JSON.stringify(this.form[key]))
            } else if (typeof this.form[key] === 'object' && !['image', 'transcript', 'audio'].includes(key)) {
              // Handle arrays
              this.form[key].forEach((item) => {
                data.append(`${key}[]`, item)
              })
            } else {
              // Handle other types
              data.append(key, this.form[key])
            }
          }
        }
        response = await this.update({
          // id: this.$route.params.id,
          data
        })
        // if (this.$route.params.id) {

        // } else {
        //   response = await this.create(data)
        // }
        // this.$router.push({
        //   name: 'mantra-list'
        // })
        // this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    handleAudioUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.form.audio && this.form.audio.src) {
        URL.revokeObjectURL(this.form.audio.src)
      }
      // 2. Create the audio link to the file to optimize performance:
      this.preview_audio = URL.createObjectURL(file)
      this.form.audio = file
    },

    toggleTranscriptModal() {
      this.isTranscriptModalOpen = !this.isTranscriptModalOpen // Toggle modal visibility
    },
    handleTranscriptUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Ensure it's a JSON file
      if (file.type !== 'application/json') {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid file type, please upload a JSON file',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Read the file content
      const reader = new FileReader()
      reader.onload = (event) => {
        try {
          const jsonData = JSON.parse(event.target.result)
          // Validate the structure of the JSON data
          if (this.validateJsonFormat(jsonData)) {
            // Assign the file to form.transcript and preview_transcript if valid
            this.form.transcript = file
            this.preview_transcript = jsonData // Store the parsed JSON data for preview
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Invalid JSON format. Please upload a valid format.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
          }
        } catch (err) {
          // If parsing fails
          this.$vs.notify({
            title: 'Error',
            text: 'Invalid JSON content',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      }

      reader.readAsText(file)
    },

    validateJsonFormat(jsonData) {
      // Check if "results" is an array
      if (!jsonData.results || !Array.isArray(jsonData.results)) {
        return false
      }
      // Validate each item in the results array
      for (const item of jsonData.results) {
        if (typeof item.transcript !== 'string' || typeof item.startTime !== 'number' || typeof item.endTime !== 'number') {
          return false
        }
        // Optional: Add more validation rules if needed
      }
      return true
    },

    /** navigate to list */
    navigateList() {
      this.$router.push({ name: 'mantra-list' })
    },

    /** file upload  */
    handleFileUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      const blob = URL.createObjectURL(file)
      this.crop_image = {
        src: blob,
        type: file.type
      }
      // e.target.value = ''
      this.IsOpenImageCrop = true

      // Increment fileKey to force re-render
      this.fileKey++
    },
    cropImage() {
      const result = this.$refs.cropper.getResult()
      if (result.canvas == undefined) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Image',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const resultTest = result.canvas.toDataURL(this.crop_image.type)
      const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '')
      this.b64toBlob(base64Image, this.crop_image.type)

      this.IsOpenImageCrop = false
    },
    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, 'image.jpg', {
        type: contentType
      })
      this.form.image = blob
      this.preview_image = URL.createObjectURL(blob)
      return blob
    },
    transformApiData(apiData) {
      const rowTags = {}
      const mappedData = apiData.map((item) => {
        const row = {
          path: {},
          transliteration: {},
          vyakhya: {},
          _id: item._id
        }

        item.slok_n_pauri_catalog.forEach((catalog) => {
          // Ensure that `catalog._id` is valid and lowercase
          const type = catalog._id.toLowerCase()

          catalog.data.forEach((entry) => {
            // Handle entry language and content
            const language = entry.language.toLowerCase()

            row[type][language] = {
              content: entry.content,
              id: entry._id // Assuming `_id` is the field you want to include
            }
          })
        })

        rowTags[item._id] = {
          audios: item.audios ? item.audios.map(a => a._id || a) : [],
          videos: item.videos ? item.videos.map(v => v._id || v) : [],
          emotions: item.emotions || []
        }
        return row
      })
      this.rowTags = rowTags
      return mappedData
    },

    /** Update Slock Single Line  */
    async updateSingleRecord(record, fieldName) {
      // Validate the specific field
      const isValid = await this.$validator.validate(fieldName)

      if (!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      const { id, content } = record
      try {
        const { message } = await this.updateSingleLine({
          id,
          data: { content }
        })
        // this.getDetail()
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 10000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** Open Tag Modal */
    openTagModal(row, type) {
      this.tagRowId = row._id
      this.tagSearchQuery = ''

      // Restore previously saved tags for this row
      const saved = this.rowTags[row._id] || {}
      this.selectedAudios = saved.audios ? [...saved.audios] : []
      this.selectedVideos = saved.videos ? [...saved.videos] : []
      this.selectedEmotions = saved.emotions ? [...saved.emotions] : []

      if (type === 'audio') {
        this.showAudioTagModal = true
      } else if (type === 'video') {
        this.showVideoTagModal = true
      } else if (type === 'emotion') {
        this.showEmotionsTagModal = true
      }
    },

    /** Save Tag */
    async saveTag(type) {
      // Ensure the rowTags entry exists for this row
      if (!this.rowTags[this.tagRowId]) {
        this.$set(this.rowTags, this.tagRowId, { audios: [], videos: [], emotions: [] })
      }

      // Persist selections into the rowTags map locally
      if (type === 'audio') {
        this.$set(this.rowTags[this.tagRowId], 'audios', Array.isArray(this.selectedAudios) ? [...this.selectedAudios] : [this.selectedAudios])
      } else if (type === 'video') {
        this.$set(this.rowTags[this.tagRowId], 'videos', Array.isArray(this.selectedVideos) ? [...this.selectedVideos] : [this.selectedVideos])
      } else if (type === 'emotion') {
        this.$set(this.rowTags[this.tagRowId], 'emotions', [...this.selectedEmotions])
      }

      try {
        const payload = {
          book: this.form.book || this.$route.params.id,
          fragment: {
            _id: this.tagRowId,
            audios: this.rowTags[this.tagRowId].audios,
            videos: this.rowTags[this.tagRowId].videos,
            emotions: this.rowTags[this.tagRowId].emotions
          }
        }

        await this.fragmentUpdate(payload)

        if (type === 'audio') this.showAudioTagModal = false
        else if (type === 'video') this.showVideoTagModal = false
        else if (type === 'emotion') this.showEmotionsTagModal = false

        this.$vs.notify({
          title: 'Success',
          text: `${type.charAt(0).toUpperCase() + type.slice(1)} tags saved successfully`,
          color: 'success',
          position: 'top-center'
        })
      } catch (error) {
        console.error('Error saving tags:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to save tags to database',
          color: 'danger',
          position: 'top-center'
        })
      }
    },

    /** Toggle Emotion Selection */
    toggleEmotion(value) {
      const idx = this.selectedEmotions.indexOf(value)
      if (idx > -1) {
        this.selectedEmotions.splice(idx, 1)
      } else {
        this.selectedEmotions.push(value)
      }
    },

    /** Toggle Body Scroll when Modals Open/Close */
    toggleBodyScroll() {
      const isAnyOpen =
        this.showAudioTagModal ||
        this.showVideoTagModal ||
        this.showEmotionsTagModal
      document.body.style.overflow = isAnyOpen ? 'hidden' : 'auto'
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    showAudioTagModal() {
      this.toggleBodyScroll()
    },
    showVideoTagModal() {
      this.toggleBodyScroll()
    },
    showEmotionsTagModal() {
      this.toggleBodyScroll()
    }
  }
}
</script>
<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
.small-icon-button .vs-button--icon {
  font-size: 13px; /* Adjust this size as needed */
}
.small-icon-button.vs-button {
  padding: 13px !important;
}
.small-icon-button.includeIconOnly {
  width: 13px !important;
  height: 13px !important;
}

.tag-pill {
  padding: 8px 16px !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  height: auto !important;
  white-space: nowrap;
}

.tag-pill:hover {
  background: rgba(var(--vs-primary), 0.1) !important;
}

.tag-modal .vs-popup {
  width: 600px !important;
}

/* Emotions Grid */
.emotions-modal .vs-popup {
  width: 560px !important;
}

.emotions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.emotion-card {
  position: relative;
  background: #f5f5f5;
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 16px 8px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.emotion-card:hover {
  background: #ebebeb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.emotion-card--selected {
  background: #f0f4ff;
}

.emotion-card__check {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.emotion-card--selected .emotion-card__check {
  background-color: black;
}

.emotion-card__emoji {
  font-size: 42px;
  line-height: 1;
  margin: 6px 0;
}

.emotion-card__label {
  font-size: 13px;
  font-weight: 600;
  color: black;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}

.emotion-card--selected .emotion-card__label {
  color: var(--vs-primary, #5381ac);
}
</style>
